(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !window.DesignMode) return;
  try {
    
class CollectionSlider {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.collections-track');
    this.slides = container.querySelectorAll('.collection-slide');
    this.prevButton = container.querySelector('.prev-button');
    this.nextButton = container.querySelector('.next-button');
    
    this.slideWidth = 0;
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    
    this.init();
  }
  
  init() {
    this.calculateSlideWidth();
    this.setupEventListeners();
    this.updateButtonStates();
    
    // Recalculate on window resize
    window.addEventListener('resize', () => {
      this.calculateSlideWidth();
      this.goToSlide(this.currentIndex);
    });
  }
  
  calculateSlideWidth() {
    const slide = this.slides[0];
    if (slide) {
      this.slideWidth = slide.offsetWidth + 20; // Include gap
    }
  }
  
  setupEventListeners() {
    this.prevButton.addEventListener('click', () => this.prev());
    this.nextButton.addEventListener('click', () => this.next());
    
    // Add touch support
    let startX = 0;
    let isDragging = false;
    let currentTranslate = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
      currentTranslate = this.getCurrentTranslate();
    }, { passive: true });
    
    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      
      const currentX = e.touches[0].clientX;
      const diff = currentX - startX;
      this.track.style.transform = `translateX(${currentTranslate + diff}px)`;
    }, { passive: true });
    
    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      
      const currentX = e.changedTouches[0].clientX;
      const diff = currentX - startX;
      
      if (Math.abs(diff) > this.slideWidth / 4) {
        if (diff > 0) {
          this.prev();
        } else {
          this.next();
        }
      } else {
        this.goToSlide(this.currentIndex);
      }
      
      isDragging = false;
    });
  }
  
  getCurrentTranslate() {
    const style = window.getComputedStyle(this.track);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    }
  }
  
  next() {
    if (this.currentIndex < this.totalSlides - 3) {
      this.goToSlide(this.currentIndex + 1);
    }
  }
  
  goToSlide(index) {
    this.currentIndex = index;
    const offset = -index * this.slideWidth;
    this.track.style.transform = `translateX(${offset}px)`;
    this.updateButtonStates();
  }
  
  updateButtonStates() {
    this.prevButton.classList.toggle('disabled', this.currentIndex === 0);
    this.nextButton.classList.toggle('disabled', this.currentIndex >= this.totalSlides - 3);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.section-scrollable-collections');
  sliders.forEach(slider => new CollectionSlider(slider));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !window.DesignMode) return;
  try {
    
class ProductCarousel {
  constructor(container) {
    this.container = container;
    this.carousel = container.querySelector('.product-carousel');
    this.products = container.querySelectorAll('.product-card');
    this.prevButton = container.querySelector('.carousel-nav__button--prev');
    this.nextButton = container.querySelector('.carousel-nav__button--next');
    this.currentIndex = 0;
    this.maxIndex = this.products.length - 1;
    
    this.init();
  }

  init() {
    if (!this.carousel || this.products.length <= 1) return;
    
    this.prevButton.addEventListener('click', () => this.navigate('prev'));
    this.nextButton.addEventListener('click', () => this.navigate('next'));
    this.updateButtons();
  }

  navigate(direction) {
    const newIndex = direction === 'next' 
      ? Math.min(this.currentIndex + 1, this.maxIndex)
      : Math.max(this.currentIndex - 1, 0);
      
    if (newIndex !== this.currentIndex) {
      this.products[this.currentIndex].classList.add('hide');
      this.products[newIndex].classList.remove('hide');
      this.currentIndex = newIndex;
      this.updateButtons();
    }
  }

  updateButtons() {
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex === this.maxIndex;
    
    this.prevButton.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
    this.nextButton.style.opacity = this.currentIndex === this.maxIndex ? '0.5' : '1';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.pre-spring-collection');
  sections.forEach(section => new ProductCarousel(section));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
